export type PrepVideo = {
  title: string;
  teacher: string;
  gradeLabel: string;
  grades: number[];
  embed: string;
  cover: string;
};

const mk = (hash: string, teacher: string, gradeLabel: string, grades: number[]): PrepVideo => ({
  title: TITLE,
  teacher,
  gradeLabel,
  grades,
  embed: embed(hash),
  cover: `/covers/${hash}.jpg`,
});

const embed = (hash: string) =>
  `https://www.aparat.com/video/video/embed/videohash/${hash}/vt/frame`;

const TITLE = "کلاس آمادگی هوش ریاضیات کانگورو";

export const prepVideos: PrepVideo[] = [
  ...["ubs204h", "fxo4cuh", "otl7gk6"].map((h) => mk(h, "استاد خدادی", "پایه اول و دوم", [1, 2])),
  ...["eobkj1u", "ieob824", "xkhqr18"].map((h) => mk(h, "استاد رنجبری", "پایه سوم و چهارم", [3, 4])),
  ...["fraonj0", "kqa0493", "sldp7hr"].map((h) => mk(h, "استاد رنجبری", "پایه پنجم و ششم", [5, 6])),
  ...["spa50bi", "yno4m2u", "qqbxb30"].map((h) => mk(h, "استاد رنجبری", "پایه هفتم و هشتم", [7, 8])),
];